export function isNumber(value: any) {
  if (typeof value === 'number') {
    // eslint-disable-next-line sonarjs/no-identical-expressions
    return value - value === 0;
  }
  if (typeof value === 'string' && !!value.trim()) {
    return isFinite(+value);
  }

  return false;
}
